export const insuranceReportTrackingIds = {
  addPayerConnectionButton: 'insurance-report:add-payer-connection-button',
};
